import { useMemo } from 'react'
import { useAppSelector } from 'hooks/reduxHooks'
import getIsLoyaltyEnabled from 'loyalty/selectors/getIsLoyaltyEnabled'
import getHasLoyaltyAccount from 'loyalty/selectors/getHasLoyaltyAccount'
import useUserHasLoyaltyBenefit from 'loyalty/hooks/useUserHasLoyaltyBenefit'

const SOCIETE_STAY_UPGRADE_ELIGIBLE_TIERS: ReadonlyArray<App.LoyaltyTier> = ['silver', 'gold', 'platinum']

function useShouldShowSocieteStayUpgradeCarousel(): boolean {
  const loyaltyEnabled = useAppSelector(getIsLoyaltyEnabled)
  const hasLoyaltyAccount = useAppSelector(getHasLoyaltyAccount)
  const loyaltyTier = useAppSelector(state => state.loyalty.account.data?.tier)
  const hasStayUpgradeBenefitAvailable = useUserHasLoyaltyBenefit('hotel_upgrade')

  return useMemo(() => {
    if (!loyaltyEnabled || !hasLoyaltyAccount || !loyaltyTier) {
      return false
    }

    if (!hasStayUpgradeBenefitAvailable) {
      return false
    }

    return SOCIETE_STAY_UPGRADE_ELIGIBLE_TIERS.includes(loyaltyTier)
  }, [hasLoyaltyAccount, hasStayUpgradeBenefitAvailable, loyaltyEnabled, loyaltyTier])
}

export default useShouldShowSocieteStayUpgradeCarousel
